import { getPerspectiveId } from "@app/lib/perspective";
import RuleDetailPage, {
  ruleDetailQuery,
} from "@app/pages/rule-detail/rule-detail-page";
import type { ruleDetailPage_Query } from "@app/queries/ruleDetailPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/rules_/$ruleId")({
  loader: ({ params }) =>
    loadQuery<ruleDetailPage_Query>(
      environment,
      ruleDetailQuery,
      { ruleId: params.ruleId, perspectiveId: getPerspectiveId() ?? undefined },
      { fetchPolicy: "network-only" }
    ),
  head: ({ params }) => pageHead(`Rule ${params.ruleId}`),
  component: RuleDetailRoute,
});

function RuleDetailRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading rule</div>}
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Loading rule...</div>}
      >
        <RuleDetailPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
